import { createAction, props } from '@ngrx/store';

export const edgeUpsertSupportedLanguages = createAction(
  '[EdgeSupportedLanguage] Edge Upsert Language Model',
  props<{ supportedLanguages: Microsoft.VideoIndexer.Contracts.SupportedLanguageContract[] }>()
);

export const edgeLoadSupportedLanguageFailed = createAction('[EdgeSupportedLanguage] Edge Failed load Supported Languages');
